import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedNew202511: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_new_202511",
  type: "adPerformancePeriod",
  scope: "NEW_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2025-11-01",
  endDate: "2025-11-30",
  impressions: 56606,
  clicks: 1153,
  adsSpendDollars: 2520,
  budgetDollars: 2600,
  salesDollars: 7724,
  bestEstimateRoas: 3.07,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.97,
  newCustomersAcquired: 20,
  dataAvailableAtDate: "2025-12-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
